// extracted by mini-css-extract-plugin
export default {"disabledNoteTooltip":"ZjfjRittvXnI2QCPqzE1__disabledNoteTooltip___","paywallIcon":"HuI2_r04O3CQDGodvHMz__paywallIcon___"};